import { useState } from 'react';
import { useAuth } from 'react-oidc-context';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, Divider, Field, Input, Image } from '@fluentui/react-components';
import { PasswordRegular, PersonRegular } from "@fluentui/react-icons";
import { loginStyles } from './login.styles';
import logo192 from '../../assets/logo192.png';

export function Login() {

  var navigate = useNavigate();
  const location = useLocation();

  const auth = useAuth();
  const [userName, setUserName] = useState("")
  const [password, setPassword] = useState("")
  // Generic, credential-free message only: never surface raw OIDC/server
  // error text (which can include client/config details) to the UI.
  const [loginError, setLoginError] = useState("")

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setLoginError("");

    try {
      var user = await auth.signinResourceOwnerCredentials({
        username: userName,
        password: password,
        skipUserInfo: true
      })

      if (user) {
        // Preserve the full query string (debug/address/country/location/
        // elementType, ...) that brought the user to /login so the original
        // request context survives the redirect back to the app.
        navigate(`/${location.search}`);
      }
    } catch {
      // Any sign-in failure (invalid credentials, client/config rejection,
      // network error, ...) must be surfaced visibly instead of silently
      // leaving the user on the login page with no feedback.
      setLoginError("Login failed. Please check your username and password and try again.");
    }
  }

  const styles = loginStyles();
  return (
    <div className={styles.container} data-testid="login-shell">
      <div className={styles.root}>
        <form onSubmit={handleSubmit}>
          <div className={styles.image}>
            <Image
              alt="BIM Comply"
              src={logo192}
              shape="circular"
              width={80}
              height={80}
              fit="center"
            />
          </div>
          <div className={styles.inputList}>
            <Field
              className={styles.input}
              label="Username"
              validationState="none"
              validationMessage=""
              required
            >
              <Input size="large" contentBefore={<PersonRegular />} value={userName}
                onChange={e => setUserName(e.target.value)} />
            </Field>
            <Field
              className={styles.input}
              label="Password"
              validationState={loginError ? "error" : "none"}
              validationMessage={loginError}
              required
            >
              <Input
                type="password"
                size="large"
                contentBefore={<PasswordRegular />}
                value={password}
                onChange={e => setPassword(e.target.value)}
              />
            </Field>

            <div className={styles.buttons}>
              <Button type="submit" size="large" className={styles.button} appearance="primary">
                Login
              </Button>
              <span>
                <a href="https://www.bimcomply.com/authentication/forgot-pwd" target='_blank' rel="noreferrer" className={styles.forgotPassword}>Forgot Password ?&nbsp;</a>
              </span>
            </div>

            <div className={styles.newToBIMComply}>New to BIMComply?
              <a href="https://www.bimcomply.com/authentication/register" target='_blank' rel="noreferrer" className={styles.createAccount}>
                Create an Account</a>
            </div>

            <div className={styles.copyRightFont}>
              Build Compliant. Build Confident.
            </div>
            <div className={styles.copyRightSubFont}>
              Validate your BIM models against building codes in real-time.
            </div>
          </div>
          <div style={{ marginTop: "30px" }}>
            <Divider className={styles.termsText}>
              By accessing BIM Comply, you are agreeing to BIM Comply's Terms of Service and Privacy Policy.
            </Divider>
          </div>
        </form>
      </div>
    </div>
  );
};